import { render } from "./ChampionshipSchedule.vue?vue&type=template&id=fbbd13d0"
import script from "./ChampionshipSchedule.vue?vue&type=script&lang=js"
export * from "./ChampionshipSchedule.vue?vue&type=script&lang=js"

import "./ChampionshipSchedule.vue?vue&type=style&index=0&id=fbbd13d0&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__